import Icon from './Icon';

const Disliked = (props) => (
  <Icon
    {...props}
    path="M72.5 10.2c0.663 0 1.299 0.263 1.768 0.732s0.732 1.105 0.732 1.768v36.4c0 0.663-0.263 1.299-0.732 1.768s-1.105 0.732-1.768 0.732c-0.663 0-1.299-0.263-1.768-0.732s-0.732-1.105-0.732-1.768v-36.4c0-0.663 0.263-1.299 0.732-1.768s1.105-0.732 1.768-0.732z M18.304 52.134h15.2l-2.166 10.5v1.167c0.008 0.759 0.131 1.512 0.366 2.233 0.561 1.471 1.608 2.706 2.966 3.5 1.3 0.831 2.847 1.185 4.379 1.003s2.953-0.89 4.021-2.003l15.8-15.933c0.796-0.767 1.425-1.69 1.85-2.71s0.634-2.118 0.617-3.223v-28.967c0-2.195-0.87-4.301-2.419-5.857s-3.652-2.434-5.847-2.443h-26.1c-1.621-0.003-3.208 0.474-4.56 1.369s-2.41 2.17-3.040 3.665l-8.8 20.5c-0.367 0.969-0.559 1.997-0.566 3.033v5.867c0.009 2.199 0.886 4.305 2.441 5.859s3.66 2.432 5.859 2.441z"
  />
);

export default Disliked;
